// Toggle password visibility
export function initInputs(container = document) {
  // Gérer le toggle password
  const passwordToggles = container.querySelectorAll('[data-toggle-password]');
  
  passwordToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const targetId = toggle.getAttribute('data-toggle-password');
      const input = document.getElementById(targetId);
      
      if (!input) return;
      
      const isPassword = input.type === 'password';
      input.type = isPassword ? 'text' : 'password';
      
      // Changer l'icône (si vous utilisez des SVG)
      const iconShow = toggle.querySelector('.icon-show');
      const iconHide = toggle.querySelector('.icon-hide');
      
      if (iconShow && iconHide) {
        iconShow.style.display = isPassword ? 'none' : 'block';
        iconHide.style.display = isPassword ? 'block' : 'none';
      }
    });
  });
  
  container.querySelectorAll('[data-clear-input]').forEach(button => {
    button.addEventListener('click', () => {
      const input = document.getElementById(button.getAttribute('data-clear-input'));
      if (!input) return;
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    });
  });

  // Auto-resize pour les inputs numériques (optionnel)
  const numberInputs = container.querySelectorAll('input[type="number"]');
  
  numberInputs.forEach(input => {
    input.addEventListener('wheel', (e) => {
      e.preventDefault(); // Empêcher le scroll de changer la valeur
    });
  });
  
}